import {
  ChartLineIcon,
  GaugeIcon,
  HandCoinsIcon,
  LayersIcon,
  LinkIcon,
  UnlinkIcon,
  UserIcon,
} from "wealthmode-frontend/icons"

const _nav = [
  {
    name: "Dashboard",
    to: "/dashboard",
    icon: GaugeIcon,
  },
  {
    title: true,
    name: "Data",
  },
  {
    name: "Clients",
    to: "/clients",
    icon: UserIcon,
  },
  {
    name: "Instruments",
    to: "/instruments",
    icon: LayersIcon,
  },
  {
    name: "Assets",
    to: "/assets",
    icon: ChartLineIcon,
  },
  {
    name: "Contribution Limits",
    to: "/contribution_limits",
    icon: HandCoinsIcon,
  },
  {
    name: "Connectors",
    to: "/connectors",
    icon: LinkIcon,
  },
  {
    name: "Unlinked",
    to: "/provider_connectors",
    icon: UnlinkIcon,
  },
]

export default _nav
